import { action } from 'src/store/actions';

export const FETCH_REPAIR_MANAGEMENT = 'FETCH_REPAIR_MANAGEMENT';
export const REQUEST_REPAIR_MANAGEMENT = 'REQUEST_REPAIR_MANAGEMENT';
export const SUCCESS_REPAIR_MANAGEMENT = 'SUCCESS_REPAIR_MANAGEMENT';
export const FAILURE_REPAIR_MANAGEMENT = 'FAILURE_REPAIR_MANAGEMENT';

export const fetchRepairManagement = (repMgmt: number) => action(FETCH_REPAIR_MANAGEMENT, { repMgmt });
export const requestRepairManagement = () => action(REQUEST_REPAIR_MANAGEMENT);
export const requestRepairManagementSuccess = (response: any) => action(SUCCESS_REPAIR_MANAGEMENT, { response });
export const requestRepairManagementFailure = (error: any) => action(FAILURE_REPAIR_MANAGEMENT, { error });
